import axios from "axios";
import { UrlService } from "@nuskin/ns-util";
import { getConfiguration } from "@nuskin/configuration-sdk";

/**
 * To get the promontional prices from equinox storefront
 *
 */

export const fetchPromotionalPrices = async product => {
  try {
    const payload = buildPayload(product);
    const options = {
      method: "POST",
      endpoint: `catalogs/products/${product.sku}/promotions`,
      data: payload
    };

    const { data } = await _equinoxRequest(options);
    return {
      price: data.unitValue.priceAfterDiscount,
      originalPrice: data.unitValue.originalPrice
    };
  } catch (err) {
    console.log("Error while fetching promotional prices");
    return {};
  }
};

const buildPayload = product => {
  const payload = {
    productId: product.sku,
    categoryId: ["all_products"],
    quantity: 1,
    skus: [],
    isSubscriptionIncludedInPromotion: false,
    isFromBrowse: true
  };

  try {
    let personalOffer = sessionStorage.getItem("personalOffer");
    if (personalOffer !== null) {
      personalOffer = JSON.parse(personalOffer);
    } else {
      personalOffer = { products: [] };
    }
    const matchedProduct = personalOffer.products.filter(
      offerProduct => offerProduct.sku === product.sku
    );
    const selectedVariants =
      matchedProduct &&
      matchedProduct.length > 0 &&
      matchedProduct[0].variantSelected
        ? matchedProduct[0].variantSelected
        : null;

    const skus = [];
    if (product && product.childSkus) {
      product.childSkus.forEach(childSku => {
        if (
          childSku.type === "MANDATORY" &&
          !skus.some(sku => sku.productId === childSku.productId)
        ) {
          skus.push({
            skuId: childSku.skuId,
            productId: childSku.productId,
            type: "bundle",
            quantity: childSku.skuQuantity
          });
        }
      });

      if (selectedVariants !== null) {
        for (const productId in selectedVariants) {
          let isOptionalProduct = true;
          skus.forEach(finalSku => {
            if (finalSku.productId === productId) {
              isOptionalProduct = false;
              finalSku.skuId = selectedVariants[productId];
            }
          });

          if (isOptionalProduct) {
            // this means this is optional product
            const optionalProduct = product.childSkus.filter(
              childSku => childSku.productId === productId
            )[0];
            if (optionalProduct) {
              skus.push({
                skuId: selectedVariants[productId],
                productId: optionalProduct.productId,
                type: "bundle",
                quantity: optionalProduct.skuQuantity
              });
            }
          }
        }
      }
    }

    payload.skus = skus;
    payload.quantity =
      matchedProduct && matchedProduct.qty ? matchedProduct.qty : 1;
  } catch (err) {
    console.log("Error while building payload");
  }

  return payload;
};

const _equinoxRequest = async options => {
  const {
    marketLocale,
    storeId,
    storefrontURL,
    headers
  } = await getEquinoxRequestConfiguration();
  const equinoxParams = {
    locale: marketLocale,
    storeId: storeId
  };

  let orchestrationURL = `${storefrontURL}/orchestrationservices/storefront/${options.endpoint}`;
  if (storefrontURL && storefrontURL.indexOf("apis") > -1) {
    orchestrationURL = `${storefrontURL}/${options.endpoint}`;
  }
  let axiosRequest = {
    method: options.method,
    url: orchestrationURL,
    headers: headers,
    withCredentials: options.method !== "DELETE",
    params: equinoxParams
  };

  if (options.data) {
    axiosRequest.data = options.data;
  }

  return axios(axiosRequest);
};

const getEquinoxRequestConfiguration = async () => {
  const marketLocale = UrlService.getLocale();
  const config = (await getConfiguration(["Equinox_Markets"])).Equinox_Markets;
  const storefrontURL = config.API_Base_URLs;

  const sessionData = sessionStorage.getItem("oktaTokens");
  const parsedSessionData = JSON.parse(sessionData);
  const sessionOktaToken =
    parsedSessionData && parsedSessionData.accessToken
      ? parsedSessionData.accessToken
      : "";
  const localStorageOktaToken = localStorage.getItem("equinox-okta-token");

  let oktaToken = localStorageOktaToken
    ? localStorageOktaToken
    : sessionOktaToken;

  const headers = {
    Accept: "*",
    "Content-Type": "application/json",
    Authorization: `Bearer ${oktaToken}`
  };

  const shoppingContext =
    window &&
    window.aem &&
    window.aem.ShoppingContext &&
    window.aem.ShoppingContext.getShoppingContext();
  if (shoppingContext && shoppingContext.overrides) {
    headers.showwholesalepricing =
      shoppingContext.overrides.showWholeSalePricing;
  }

  return {
    marketLocale,
    storeId: config.store_id,
    storefrontURL,
    headers
  };
};
